import type { ReactElement } from 'react';
import StatesEnum from '@/utils/enums/StatesEnum';

type Props = {
  isV3: boolean;
  currentState: string;
  // eslint-disable-next-line react/require-default-props
  paymentMethod?: string;
};

function DescriptionText(props: Props): ReactElement {
  const { isV3, currentState, paymentMethod } = props;

  const isScoreReproved = currentState === StatesEnum.SCORE_DISAPPROVED;
  const isReproved =
    currentState === StatesEnum.DISAPPROVED ||
    currentState === StatesEnum.CREDIT_DISAPPROVED;

  const descriptionText = () => {
    if (isReproved) {
      return (
        <p>
          Infelizmente, o seu crédito não foi aprovado numa primeira análise.
          Para prosseguir, por favor, indique duas novas pessoas avalistas.
        </p>
      );
    }

    if (isV3 || paymentMethod === 'fifteen_delay') {
      if (isScoreReproved) {
        return (
          <p>
            Ainda não foi possível aprovar o seu crédito, mas estamos quase lá!
            Para prosseguir com sua análise, por favor, indique mais uma pessoa
            avalista.
          </p>
        );
      }
      return <p>Revise com atenção os dados antes de confirmar o envio.</p>;
    }
    return (
      <>
        <p className="register-gurantors-container__desciption-element--bottom-distance">
          Essas pessoas apoiarão seu financiamento, como uma garantia. As duas
          pessoas passarão pela análise de crédito e, caso sejam aprovadas,
          assinarão o documento para contratação do financiamento do Modelo de
          Sucesso Compartilhado.{' '}
          <a
            href="https://ajuda.betrybe.com/hc/pt-br/articles/360059567673-Por-que-s%C3%A3o-necess%C3%A1rios-avalistas-para-assinar-a-c%C3%A9dula-de-cr%C3%A9dito-banc%C3%A1rio-CCB-"
            target="_blank"
            rel="noreferrer"
          >
            <span className="register-gurantors-container__desciption-element--link">
              Saiba mais.
            </span>
          </a>
        </p>

        <p>
          Você pode indicar uma pessoa que você conheça e que, de preferência,
          seja da sua família. 🏠
        </p>
      </>
    );
  };

  return <>{descriptionText()}</>;
}

export default DescriptionText;
